import axios from 'axios';

export const getBlob = async (url: string) => {
  return await axios.get(url, {
    responseType: 'blob',
  });
};
